var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fas fa-leaf pr-2",class:_vm.productType === _vm.rawMaterialTypeEko ? "color-green" : "color-red",attrs:{"title":_vm.productType === _vm.rawMaterialTypeEko ? "Eko" : "Konwencja"}})
}
var staticRenderFns = []

export { render, staticRenderFns }